
import { PropType } from 'vue'
import { Anexo } from '@/models/anexo_model'

const TEMPO_AVISO_MSG_ERRO = 10000;
const TAMANHO_MAX = 5119500; //5MB

export default {
    name: 'pessoaAnexos',
    props: {
        value: {
            type: Array as PropType<Anexo[]>,
            required: true
        }
    },
    data: () => ({
        arquivo: undefined,
        anexos: [] as Anexo[],
        anexoJaExiste: false,
        anexosExcluidos: [],
        msgErroArquivo: ''
    }),

    mounted() {
        this.anexos = [...this.value]
    },

    methods: {

        adicionarAnexo(e:Event) {
            const target = e.target as HTMLInputElement;
            const files = target.files;
            if (!files || !files[0]) {
                return;
            }
            const _anexo = new Anexo();

            _anexo.estendeArquivo(files[0]);

            this.anexoJaExiste = false;

            for (let i = 0; i < this.anexos.length; i++) {
                if (_anexo.nome === this.anexos[i].nome) {
                    return this._exibeMsgErroArquivo('O arquivo já existe.');
                }
            }

            if (_anexo.tamanho && _anexo.tamanho > TAMANHO_MAX) {
                return this._exibeMsgErroArquivo("O arquivo informado ultrapassou o limite de tamanho de 5MB.");
            }

            this.anexos.unshift(_anexo);
            this.arquivo = undefined;
        },

        excluirAnexo(idAnexo:string, selecionadoEm:Date, anexosExcluidos:string[]) {
            for (var i = 0, _tamanho = this.anexos.length; i < _tamanho; i++) {
                var _an = this.anexos[i];

                if ((_an.selecionadoEm && (_an.selecionadoEm === selecionadoEm)) || (_an.idAnexo && (_an.idAnexo === idAnexo))) {
                    this.anexos.splice(i, 1);
                    anexosExcluidos.push(_an.idAnexo);
                    break;
                }
            }
        },

        _exibeMsgErroArquivo(msg:string) {
            this.msgErroArquivo = msg;

            setTimeout(() => {
                this.msgErroArquivo = '';
            }, TEMPO_AVISO_MSG_ERRO);
        }
    },
    watch: {
        anexos() {
            this.$emit('update', this.anexos)
        },
        anexosExcluidos() {
            this.$emit('atualizaAnexosExcluidos', this.anexosExcluidos)
        }
    }
};
